import api from "@/apis/LocationAPI";
import Crud from "./crud-base";
var crud = new Crud("Location", api);

const state = {
  ...crud.state,
  _config: {
    field: {
      key: "LocationID",
      name: "LocationName",
      code: "LocationCode",
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: import.meta.env.PROD,
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
